var map = {
	"./cnn-money-x2.png": 1941,
	"./economist-x2.png": 1942,
	"./mashable-x2.png": 1943,
	"./tech-crunch-x2.png": 1944,
	"./thenewyorker-x2.png": 1945,
	"./thrillist-x2.png": 1946,
	"./time-x2.png": 1947,
	"./usa-today-x2.png": 1948
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2159;